import { render, staticRenderFns } from "./articleCenter.vue?vue&type=template&id=e9465af8&scoped=true&"
import script from "./articleCenter.vue?vue&type=script&lang=js&"
export * from "./articleCenter.vue?vue&type=script&lang=js&"
import style0 from "./articleCenter.vue?vue&type=style&index=0&id=e9465af8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9465af8",
  null
  
)

export default component.exports